const DEFAULT_MAX_DIMENSION = 1600;
const DEFAULT_QUALITY = 0.85;
const DEFAULT_OUTPUT_TYPE = 'image/jpeg';

export async function compressImageDataUrl(dataUrl, options = {}) {
  if (!dataUrl || typeof document === 'undefined') {
    return dataUrl;
  }

  const {
    maxDimension = DEFAULT_MAX_DIMENSION,
    quality = DEFAULT_QUALITY,
    outputType = DEFAULT_OUTPUT_TYPE,
  } = options;

  let image;
  try {
    image = await loadImage(dataUrl);
  } catch (_) {
    return dataUrl;
  }

  const sourceWidth = image.naturalWidth || image.width;
  const sourceHeight = image.naturalHeight || image.height;
  if (!sourceWidth || !sourceHeight) {
    return dataUrl;
  }

  const { width, height } = scaleToFit(sourceWidth, sourceHeight, maxDimension);
  const alreadySmall = width === sourceWidth && height === sourceHeight;
  if (alreadySmall && dataUrl.startsWith(`data:${outputType}`)) {
    return dataUrl;
  }

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return dataUrl;
  }
  ctx.drawImage(image, 0, 0, width, height);

  try {
    const compressed = canvas.toDataURL(outputType, quality);
    if (typeof compressed !== 'string' || compressed.length < 32) {
      return dataUrl;
    }
    // Этап 31: на входе может быть ссылка (картинка из истории) — тогда результат всегда
    // data URL: печатный файл самодостаточен и не должен ссылаться на сервер.
    if (!dataUrl.startsWith('data:')) {
      return compressed;
    }
    return compressed.length < dataUrl.length ? compressed : dataUrl;
  } catch (_) {
    return dataUrl;
  }
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('image load failed'));
    img.src = src;
  });
}

function scaleToFit(width, height, maxDimension) {
  if (width <= maxDimension && height <= maxDimension) {
    return { width, height };
  }
  const ratio = Math.min(maxDimension / width, maxDimension / height);
  return {
    width: Math.max(1, Math.round(width * ratio)),
    height: Math.max(1, Math.round(height * ratio)),
  };
}
